import { PaintedScene } from '../PaintedScene';

export const HEARTH_HALL_INTERIOR_PHASER_KEY = 'HearthHallInteriorScene' as const;
export const HEARTH_HALL_INTERIOR_MANIFEST_KEY = 's-309-hearthmere-interior' as const;

export class HearthHallInteriorScene extends PaintedScene {
  constructor() {
    super(HEARTH_HALL_INTERIOR_PHASER_KEY, HEARTH_HALL_INTERIOR_MANIFEST_KEY);
  }
}
